"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hex_1 = require("./hex");
const padding_1 = require("./padding");
function hexToBuffer(value) {
    if (!hex_1.isHexStrict(value)) {
        throw new Error('Not a 0x formatted hex string');
    }
    if (value.length % 2 !== 0) {
        value = padding_1.leftPad(value, value.length - 1);
    }
    return Buffer.from(value.slice(2), 'hex');
}
exports.hexToBuffer = hexToBuffer;
function bufferToHex(value) {
    return '0x' + value.toString('hex');
}
exports.bufferToHex = bufferToHex;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGV4LWJ1ZmZlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9oZXgtYnVmZmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsK0JBQW9DO0FBQ3BDLHVDQUFvQztBQUVwQyxTQUFnQixXQUFXLENBQUMsS0FBYTtJQUN2QyxJQUFJLENBQUMsaUJBQVcsQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUN2QixNQUFNLElBQUksS0FBSyxDQUFDLCtCQUErQixDQUFDLENBQUM7S0FDbEQ7SUFDRCxJQUFJLEtBQUssQ0FBQyxNQUFNLEdBQUcsQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUMxQixLQUFLLEdBQUcsaUJBQU8sQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztLQUMxQztJQUNELE9BQU8sTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQzVDLENBQUM7QUFSRCxrQ0FRQztBQUVELFNBQWdCLFdBQVcsQ0FBQyxLQUFhO0lBQ3ZDLE9BQU8sSUFBSSxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDdEMsQ0FBQztBQUZELGtDQUVDIn0=